var render = function (_h,_vm) {var _c=_vm._c;return _vm._m(0)}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"tile-content tile-content-secondary"},[_c('p',[_vm._v("Cancel all scheduled payments for the customer.")])])}]

export { render, staticRenderFns }